var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-start flex-column" },
    [
      _vm.showLabel
        ? _c(
            "v-sheet",
            {
              staticClass:
                "text--secondary pl-1 d-inline-block text-truncate transparent",
            },
            [
              _c("span", { class: _vm.labelClass }, [
                _vm._v(" " + _vm._s(_vm.$t(_vm.label)) + " "),
              ]),
            ]
          )
        : _vm._e(),
      _c("v-combobox", {
        ref: "selectdep",
        attrs: {
          items: [],
          disabled: _vm.disabled,
          "item-color": "transparent",
          multiple: _vm.multiple,
          height: "40",
          readonly: _vm.readonly,
          rules: _vm.readonly ? [] : _vm.rules,
          filled: _vm.filled,
          dense: "",
          placeholder: _vm.placeholder,
          "hide-details": "",
          "allow-overflow": false,
          "append-icon": _vm.readonly ? "" : _vm.appendIcon,
          "single-line": _vm.singleLine,
        },
        on: {
          "update:search-input": function (e) {
            _vm.search = e
          },
          "update:list-index": function () {
            return
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.curValue.length > 0
              ? {
                  key: "selection",
                  fn: function (data) {
                    return [
                      data.index < _vm.$selectSetting.maxChips
                        ? _c(
                            "v-chip",
                            _vm._b(
                              {
                                staticClass: "mx-1 my-1",
                                attrs: {
                                  close: "",
                                  small: "",
                                  "input-value": data.selected,
                                },
                                on: {
                                  click: data.select,
                                  "click:close": function ($event) {
                                    return _vm.curValue.splice(data.index, 1)
                                  },
                                },
                              },
                              "v-chip",
                              data.attrs,
                              false
                            ),
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      _vm.curValue[data.index]["org_level_name"]
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      data.index === _vm.$selectSetting.maxChips
                        ? _c("v-hover", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var hover = ref.hover
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "py-2",
                                          class: hover
                                            ? "rounded primary--text"
                                            : "text--secondary",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return function () {
                                                _vm.$emit("view-select")
                                                if (_vm.$refs.selectdep) {
                                                  _vm.$refs.selectdep.blur()
                                                }
                                              }.apply(null, arguments)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " ..." +
                                              _vm._s(
                                                _vm.curValue.length -
                                                  _vm.$selectSetting.maxChips
                                              ) +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_selection_moreItemLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  },
                }
              : null,
            {
              key: "no-data",
              fn: function () {
                return [
                  _vm.items.length == 0
                    ? _c("noContent")
                    : _c("v-treeview", {
                        attrs: {
                          selectable: "",
                          "open-all": "",
                          "open-on-click": "",
                          search: _vm.search,
                          "selected-color": "primary",
                          items: _vm.items,
                          "item-key": "uuid",
                          filter: _vm.filter,
                          "return-object": "",
                          "item-text": "org_level_name",
                          "item-children": "items",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("span", {
                                  staticClass: "text--secondary",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.hightLightKeyword(
                                        item.org_level_name,
                                        _vm.search
                                      )
                                    ),
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.curValue,
                          callback: function ($$v) {
                            _vm.curValue = $$v
                          },
                          expression: "curValue",
                        },
                      }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.curValue,
          callback: function ($$v) {
            _vm.curValue = $$v
          },
          expression: "curValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }